var MerchantFeeds = $.extend(false, BaseModule ,{

    api_route : 'merchant-feeds',

    data : {
        module          : 'merchant-feeds',
        offset:48,
        page:0,
        channel         : '',
        order_by        : 'id:desc',
        view            : 'list',
        with            : '',
        details_with    : '',
        pagination      : true
    },

    init:function(){
        var module_name = this.data.module,  module = this;
    }, 
    execute_import:function(f){
        var module_name = this.data.module;
        var module = this;
        $.ajax({data:$('form[name="'+module_name+'_form"]').serialize(),success:function(data){
            if(data.status == 'ok'){
                module.load_list();
            }else{
                show_message('nFailure',data.error);
            }
        }});
    },

     import_form:function(data){
        var module_name = this.data.module,
            module = this;
             
            
        $("#import-dialog").on('shown.bs.modal', function () {

            $("#import-dialog .btn-ok").on('click',function(){
                var $files = [];
                $('#import-dialog input[name="filename[]"]').each(function(){
                    var v = $(this).val();
                    $files.push(v);
                }); 
                $.ajax({
                    url : API + 'merchant-feeds/import',
                    data:{
                        files : $files
                    },
                    type:'PUT',
                    error:function(){
                        GlobalModule.show_message('danger','Something went wrong');
                    },
                    success:function(data){

                        GlobalModule.show_message('success','Successfuly submited. Import information is not available');

                    }
                });
                $("#import-dialog").modal('hide');

            });
            initForm('#import-dialog');

        }).on('hidden.bs.modal', function () {
            
            module.load_list();

        }).modal('show');

    },




     export:function(){
        window.location = 'api/merchant-feeds/export';
    },
    delete_filtered:function(){

        var r = confirm("Are you sure you want to delete the filtered entries?");
        if (r == true) {

          var module = this,
            module_name = module.data.module,
            request_data={}, 
            filter_data = $('.filters[data-module="'+module_name+'"]').serializeArray();  


  
         for(var i in filter_data){
            var name = filter_data[i].name, value = filter_data[i].value;
            request_data[name] = value;  

        }  

         request_data['channel'] = $('#channel-list-tabs .nav-link.active ').data('channel');

          $.ajax({
            url : API + module.api_route+'/delete_filtered',
            method:'POST',
            data:request_data,
            success:function(data){
               if(data.success){
                   alert(data.success);
                    module.load_list();
                }else{
                   alert(data.error);
                }

            }
        });
           }   
               
             
    }
});

$(document).ready(function(){
    "use strict";
    MerchantFeeds.init();
});